import dayjs from 'dayjs'

export const isDueStatus = status => status === 'VENCIDOS' || status === 'POR VENCER'

export const duePeriodOptions = (today = dayjs()) => [
  { value: '', label: 'Todos' },
  { value: 'overdue', label: 'Vencidos' },
  ...[7, 30, 60, 90].map(days => ({ value: `next-${days}`, label: `Próximos ${days} días` })),
  { value: 'this-month', label: 'Este mes' },
  { value: 'next-month', label: 'Próximo mes' },
  ...Array.from({ length: 12 }, (_, index) => {
    const month = today.add(index + 1, 'month')
    const label = `${new Intl.DateTimeFormat('es-CL', { month: 'long' }).format(month.toDate())} ${month.year()}`
    return { value: month.format('YYYY-MM'), label: label.charAt(0).toUpperCase() + label.slice(1) }
  })
]

export const duePeriodRange = (period, today = dayjs()) => {
  if (!period) return { from: '', to: '' }
  if (period === 'overdue') return { from: '', to: today.subtract(1, 'day').format('YYYY-MM-DD') }
  if (period.startsWith('next-') && period !== 'next-month') {
    return { from: today.format('YYYY-MM-DD'), to: today.add(Number(period.slice(5)), 'day').format('YYYY-MM-DD') }
  }
  const month = period === 'this-month' ? today : period === 'next-month' ? today.add(1, 'month') : dayjs(`${period}-01`)
  return { from: month.startOf('month').format('YYYY-MM-DD'), to: month.endOf('month').format('YYYY-MM-DD') }
}

const amount = value => typeof value === 'string'
  ? Number(value.replace(/\./g, '').replace(',', '.')) || 0
  : Number(value) || 0

export const matchesDueFilters = (row, { status, from, to, period, type }, today = dayjs()) => {
  const state = String(row.status ?? '').trim().toUpperCase()
  if (['PAGADO', 'COBRADO', 'CONCILIADO', 'CONCILIADA', '0'].includes(state)) return false
  const document = String(row.nombreFolio || '').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
  const isCreditNote = document === '61' || document === 'nce' || (document.includes('nota') && document.includes('credito')) || state.includes('ANULA FOLIO')
  const paid = (row.linkage || []).reduce((sum, link) => sum + amount(link.montoRelacionado), 0)
  const total = type === 'egreso' ? amount(row.haber ?? row.montoTotal) : amount(row.montoTotal ?? row.debe)
  const balance = row.auxiliar != null && String(row.auxiliar).trim() !== '' ? amount(row.auxiliar) : total - paid
  if (!isCreditNote && balance <= 0) return false
  if (!isDueStatus(status) && !from && !to && !period) return true
  const date = row.fechaVencimiento ? dayjs(String(row.fechaVencimiento).slice(0, 10)) : null
  if (!date?.isValid()) return false
  const dateString = date.format('YYYY-MM-DD')
  if ((from && dateString < from) || (to && dateString > to)) return false
  if (isDueStatus(status) || period === 'overdue') {
    const state = String(row.status || '').toUpperCase()
    const document = String(row.nombreFolio || '').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
    const paid = (row.linkage || []).reduce((sum, link) => sum + amount(link.montoRelacionado), 0)
    const total = type === 'egreso' ? amount(row.haber ?? row.montoTotal) : amount(row.montoTotal ?? row.debe)
    if (state.includes('ANUL') || ['PAGADO', 'COBRADO', '0'].includes(state) || document === '61' || document === 'nce' || (document.includes('nota') && document.includes('credito')) || total - paid <= 0) return false
    const overdue = dateString < today.format('YYYY-MM-DD')
    if (status === 'VENCIDOS' && !overdue) return false
    if (status === 'POR VENCER' && overdue) return false
    if (period === 'overdue' && !overdue) return false
  }
  return true
}
